module.exports = __webpack_public_path__ + "img/fondoArtes2.886da265.jpg";